import { IFilter } from '../../types/filters';
import { HeatingTypeContainer } from '../../containers/advancedFilters/HeatingTypeContainer';

export const heatingType: IFilter = {
  component: HeatingTypeContainer,
};
